module.exports = __webpack_public_path__ + "img/close.cdc6b0d3.png";